import { securityServicesData } from '../data/securityServicesData';
import { onBrowserSessionInvalidated } from '../services/browserState';

let currentData = securityServicesData;
let savedChanges = false;

const notifyUpdated = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('securityServicesDataUpdated'));
  }
};

onBrowserSessionInvalidated(() => {
  currentData = securityServicesData;
  savedChanges = false;
  notifyUpdated();
});

export const getSecurityServicesData = () => currentData;

export const saveSecurityServicesData = (data) => {
  currentData = data;
  savedChanges = true;
  notifyUpdated();
  return true;
};

export const resetSecurityServicesData = () => {
  currentData = securityServicesData;
  savedChanges = false;
  notifyUpdated();
  return true;
};

export const hasSavedChanges = () => savedChanges;

export const exportSecurityServicesData = () => {
  const dataStr = JSON.stringify(getSecurityServicesData(), null, 2);
  const dataBlob = new Blob([dataStr], { type: 'application/json' });
  const url = URL.createObjectURL(dataBlob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `security-services-data-${new Date().toISOString().split('T')[0]}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const importSecurityServicesData = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = event => {
    try {
      const data = JSON.parse(event.target.result);
      if (!data.services || !data.features || !data.featureServices || !data.categories) {
        throw new Error('Invalid data structure');
      }
      saveSecurityServicesData(data);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  };
  reader.onerror = () => reject(new Error('Failed to read file'));
  reader.readAsText(file);
});
